<template>
  <div class="container">
    <div v-wechat-title="($route.meta.title = name)"></div>
    <div class="bannerBox">
      <img
        class="homeIcon"
        src="../../../static/images/index/home_w.png"
        @click="toSpecialDetail"
      />
      <div
        class="banImg"
        :style="{ backgroundImage: `url(${mobileBanner})` }"
      ></div>
    </div>

    <div class="searchBox">
      <van-search
        v-model="keyword"
        placeholder="请输入搜索内容"
        @search="searchHandle"
      />
    </div>

    <div class="moduleBox" style="border: 0px">
      <div
        class="headline"
        :style="{ marginBottom: `${type == 0 ? '0px' : '40px'}` }"
      >
        {{ name }}
      </div>
      <div class="hot-box" @click="toLbRanking" v-if="type == 0">
        <img src="../../../static/images/index/label.png" class="fireIcon" />
        <span>最受关注{{ name }}</span>
        <span
          class="iconfont icon-right"
          style="font-size: 10px; color: #999"
        ></span>
      </div>
      <van-list
        class="live-box"
        :class="recType == 1 || recType == 3 ? 'live-box3' : ''"
        v-if="type == 1"
        v-model="mloading"
        :finished="mfinished"
        :error.sync="merror"
        error-text="请求失败，点击重新加载"
        :immediate-check="check"
        @load="getRecommendList"
      >
        <div
          v-for="(item, index) in enterpriseList"
          :key="index"
          class="li_item"
          @click.stop="toDetailHandle(item.ContentId, recType)"
        >
          <div class="li_top">
            <van-image :src="item.Photo" class="coverImg" />
          </div>
          <div class="li_btm">
            <div class="overFlowOne">
              {{ recType == 1 ? item.Headline : item.Title }}
            </div>
            <div class="company" v-if="recType == 2">
              <van-image fit="contain" :src="item.HeadlineLogo" />
              <div class="overFlowOne">{{ item.Headline }}</div>
            </div>
          </div>
        </div>
      </van-list>

      <van-list
        v-if="type == 0"
        class="live-box"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getMobileLiveList"
      >
        <div v-for="(item, index) in liveList" :key="index" class="li_item">
          <mini-program
            :path="
              '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
            "
          >
            <div class="li_top">
              <div class="lit_state">
                <div
                  class="lits_text"
                  :class="
                    item.Status == 1
                      ? 'orange'
                      : item.Status == 0
                      ? 'red'
                      : 'purple'
                  "
                >
                  <img
                    src="../../../static/images/index/status.gif"
                    v-if="item.Status == 0"
                  />
                  <span>{{ item.StatusDesc }}</span>
                </div>
                <div v-if="item.Status == 1" class="lits_time">
                  {{ item.StartTimeDesc }}
                </div>
              </div>
              <van-image
                fit="cover"
                :src="item.Cover"
                class="coverImg"
              ></van-image>
              <img
                src="../../../static/images/index/play.png"
                class="playIcon"
              />
            </div>
            <div class="li_btm">
              <div class="overFlowOne">{{ item.Title }}</div>
              <div class="company">
                <van-image
                  fit="cover"
                  :src="item.HeadlineLogo"
                  round
                  error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                ></van-image>
                <div class="overFlowOne">{{ item.Headline }}</div>
              </div>
            </div>
          </mini-program>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { List, Image, Search } from "vant";
import { getShareData } from "@/utils/share";
import miniProgram from "@/components/miniProgram";
import {
  liveRecommendsById,
  specialDetail,
  mobileLiveList,
} from "@/api/online";
export default {
  name: "companyLive",
  components: {
    "van-list": List,
    "van-image": Image,
    "van-search": Search,
    miniProgram,
  },
  data() {
    return {
      check: true,
      mobileBanner: "", //海报
      sid: null, //专题id
      lid: null,
      type: 0, // 0直播 1推荐位
      recType: 0, //1企业 2视频 3产品
      name: "",
      keyword: "",

      mpageIndex: 1,
      mtotal: 0,
      merror: false,
      mloading: false,
      mfinished: false,
      enterpriseList: [], //推荐位

      liveList: [],
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,
    };
  },
  methods: {
    //搜索
    searchHandle() {
      this.pageIndex = 1;
      this.mpageIndex = 1;
      this.enterpriseList = [];
      this.liveList = [];
      if (this.trim(this.keyword)) {
        if (this.type == 0) {
          this.getMobileLiveList();
        } else {
          this.getRecommendList();
        }
      }
    },

    //去除首尾的空格
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, "");
    },

    //跳转展厅或者产品
    toStoreShow(path) {
      if (path.indexOf("?") != -1) {
        if (path.split("?")[0] == "/pages/productDetail/productDetail") {
          var goodId = path.split("goodId")[1].split("=")[1];
          this.$router.push({ path: "/productDetail", query: { id: goodId } });
        } else if (path.split("?")[0] == "/pages/storeIndex/storeIndex") {
          var mid = path.split("?")[1].split("=")[1];
          this.$router.push({ path: "/storeShow", query: { mid: mid } });
        } else {
        }
      }
    },

    //获取专题详情
    getSpecialDetail() {
      var that = this;
      var data = {
        SpecialId: Number(that.$route.query.sid),
      };
      specialDetail(data).then((res) => {
        that.mobileBanner = res.Data.MobileBanner;
        getShareData(
          window.location.href,
          "2022阿拉丁网上照明展",
          unescape(that.name)
        );
      });
    },

    //跳转详情(type=1)
    toDetailHandle(id, rtype) {
      if (rtype == 1) {
        this.$router.push({ path: "/storeShow", query: { mid: mid } });
      } else if (rtype == 2) {
        this.$router.push({ path: "/videoDetail", query: { id: id } });
      } else if (rtype == 3) {
        this.$router.push({ path: "/productDetail", query: { id: id } });
      }
    },

    //跳转专题详情
    toSpecialDetail() {
      this.$router.replace({
        path: "/specificActDetail",
        query: { sid: this.$route.query.sid },
      });
    },

    //去排行榜
    toLbRanking() {
      this.$router.push({
        path: "/lbRanking",
        query: { recommend: this.$route.query.lid, sid: this.$route.query.sid, name: this.name },
      });
    },

    //获取推荐位列表
    getRecommendList() {
      var that = this;
      var data = {
        LiveRecId: that.$route.query.lid,
        Keyword: that.keyword,
        PageModel: {
          PageSize: 20,
          PageIndex: that.mpageIndex,
        },
      };
      liveRecommendsById(data)
        .then((res) => {
          that.type = res.Data.Type;
          that.name = decodeURIComponent(res.Data.RecName);
          that.recType = res.Data.RecType;
          if (that.mpageIndex == 1) {
            that.enterpriseList = [...res.Data.RecContentList];
          } else {
            that.enterpriseList = [
              ...that.enterpriseList,
              ...res.Data.RecContentList,
            ];
          }
          that.mtotal = res.Data.RecContentTotal;
          that.mpageIndex += 1;
          that.mloading = false;
          if (that.enterpriseList.length >= that.mtotal) {
            that.mfinished = true;
          }
        })
        .catch((err) => {
          that.mloading = false;
          that.merror = true;
          that.Common.showMsg(err);
        });
    },

    //获取直播列表
    getMobileLiveList() {
      var that = this;
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: that.keyword,
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
        Recommend: that.$route.query.lid,
        SpecialId: that.$route.query.sid,
        HasQrcode: 1,
      };
      mobileLiveList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.liveList = [...res.Data.List];
          } else {
            that.liveList = [...that.liveList, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.liveList.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },

  mounted() {
    this.sid = this.$route.query.sid;
    this.getSpecialDetail();
    if (this.check) {
      this.getRecommendList();
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  .bannerBox {
    height: 310px;
    position: relative;

    .homeIcon {
      position: absolute;
      z-index: 2;
      top: 12px;
      left: 11px;
      width: 30px;
      height: 30px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .banImg {
      display: block;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center top;
    }
  }

  .searchBox {
    box-sizing: border-box;
    padding: 10px 14px;
    background: linear-gradient(264deg, #a0f3f7, #b3b8f8);
    .van-search {
      width: 350px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      -webkit-border-radius: 16px;
      -moz-border-radius: 16px;
      -ms-border-radius: 16px;
      -o-border-radius: 16px;
      background-color: #fff;
      display: flex;
      align-items: center;
      font-size: 11px !important;
      /deep/.van-cell__value {
        font-size: 11px !important;
      }
      /deep/.van-search__content {
        height: 32px;
        line-height: 32px;
        padding-left: 0px;
        background-color: #fff;
        display: flex;
        align-items: center;
      }
    }
  }
}
.company {
  display: flex;
  align-items: center;
  margin-top: 7px;
}

.company .van-image {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 6px;
  display: block;
  /deep/ .van-image__img {
    border-radius: 50%;
  }
}

.company > div {
  width: 80%;
  color: #666666;
  font-size: 9px;
}
</style>


